// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wdglp","label":"styles_label__3ramX"};